import axios from 'axios'

const request = axios.create({
  baseURL: '/api',
  timeout: 10000
})

export const parkingApi = {
  getList: () => request.get('/parking-lots'),
  create: (data) => request.post('/parking-lots', data),
  update: (id, data) => request.put(`/parking-lots/${id}`, data),
  delete: (id) => request.delete(`/parking-lots/${id}`)
}

export const vehicleApi = {
  getList: (params) => request.get('/vehicles', { params }),
  entry: (data) => request.post('/vehicles/entry', data),
  exit: (id) => request.post(`/vehicles/${id}/exit`)
}

export const paymentApi = {
  getList: (params) => request.get('/payments', { params }),
  pay: (id) => request.post(`/payments/${id}/pay`)
}
